export default "__VITE_ASSET__Dt0qzqY0__"